"use client";

import { Carousel } from "@mantine/carousel";
import { Box, Paper } from "@mantine/core";
import Image from "next/image";
import { useEffect, useState } from "react";
import Autoplay from "embla-carousel-autoplay";

const DEMO_IMAGES = [
  "/outputs/deepWinter.png",
  "/outputs/deepWinter2.png",
  "/outputs/trueWarmAutumn.png",
  "/outputs/coolSummer.png",
  "/outputs/coolSummer2.png",
  "/outputs/softAutumn.png",
];

export default function DemoCarousel() {
  const [mounted, setMounted] = useState(false);
  const autoplay = Autoplay({ delay: 5000, stopOnInteraction: false });

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Carousel
      slideSize={{ base: "100%", sm: "50%", md: "33.333333%" }}
      slideGap={{ base: 0, sm: "md" }}
      emblaOptions={{ loop: true, align: "start", slidesToScroll: 1 }}
      withControls={false}
      plugins={[autoplay]}
    >
      {DEMO_IMAGES.map((src, index) => (
        <Carousel.Slide key={index}>
          <Paper shadow="md" radius="md" withBorder style={{ overflow: "hidden" }}>
            <Box style={{ position: "relative", aspectRatio: "1" }}>
              <Image
                src={src}
                alt={`Color Analysis Example ${index + 1}`}
                fill
                style={{ objectFit: "contain" }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </Box>
          </Paper>
        </Carousel.Slide>
      ))}
    </Carousel>
  );
}
